"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
var utils_1 = require("../../utils");
exports.useStyles = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        fabActions: {
            borderRadius: '1000px',
            width: 150,
            height: 56,
            border: 'none',
            cursor: 'pointer',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
            color: theme.palette.primary.contrastText,
            fontSize: utils_1.textSizeMap.text.large,
            fontWeight: utils_1.textWeightMap['semi-bold'],
        },
        fabClose: {
            borderRadius: '1000px',
            width: 130,
            height: 56,
            border: 'none',
            cursor: 'pointer',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
            color: theme.palette.primary.contrastText,
            fontSize: utils_1.textSizeMap.text.large,
            fontWeight: utils_1.textWeightMap['semi-bold'],
        },
        fabText: {
            alignItems: 'center',
            marginLeft: 12,
        },
        paper: {
            minWidth: '200px',
            boxShadow: '-2px 0 4px 0 rgba(0, 0, 0, 0.15)',
            borderRadius: 0,
        },
        menuList: {
            padding: 0,
            '& .MuiListItem-button:hover': {
                backgroundColor: theme.palette.background.default,
                '& .MuiBox-root': { fontWeight: utils_1.textWeightMap.bold },
            },
        },
        menuItem: {
            padding: '10px 12px',
        },
        itemIcon: {
            minWidth: 'unset',
            marginRight: '12px',
        },
    });
});
